import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { CopyOrderDetailsPayload, TranslationRequestInput } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = TranslationRequestInput;
type TData = CopyOrderDetailsPayload;

export const useTranslationRequestCopyOrderDetails = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation translationRequestCopyOrderDetails($input: TranslationRequestInput!) {
      translationRequestCopyOrderDetails(input: $input) {
        success
        errors
        errorCode
        guid
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
